<template>
    <v-card
        class="mx-auto"
        width="640px"
        style="padding: 0; border-radius: 30px">
        <v-card-title class="card-header">
            <h3 class="header-title">Existencias en otras sucursales</h3>
            <i
                class="mdi mdi-close-circle boton-cerrar-x"
                @click="closeDialog"></i>
        </v-card-title>
        <v-card-text style="overflow-y: auto">
            <!-- Sección de leyendas en dos columnas -->
            <div class="stock-container legend-section">
                <div class="column-container">
                    <!-- Se usa el caracter &#8203; para tener un caracter vacio y que los cuadrados se alineen -->
                    <span class="cube">&#8203;</span>
                    <span class="storeName">Si hay existencia</span>
                </div>
                <div class="column-container">
                    <span class="cube drive-thru">&#8203;</span>
                    <span class="storeName"
                        >Si hay existencia con
                        <v-tooltip text="Auto-servicio" location="top">
                            <template v-slot:activator="{ props }">
                                <span
                                    class="icono-drive-thru"
                                    v-bind="props"></span>
                            </template>
                        </v-tooltip>
                    </span>
                </div>
            </div>

            <!-- Contenido principal en dos columnas -->
            <div class="stock-container">
                <div
                    class="column-container"
                    v-for="store in sortedStores"
                    :key="store.store">
                    <span
                        class="cube"
                        :class="{
                            disabled: !store.units || store.units == 0,
                            'drive-thru': store.is_drive_thru,
                        }">
                        {{ store.units ?? 0 }}
                    </span>
                    <span class="storeName">{{
                        locationMap[store.store]?.public_name || getStoreName(store.store)
                    }}</span>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        presentation: {
            type: Object,
            default: () => ({}),
        },
        selectedPresentation: {
            type: Object,
            default: () => ({}),
        },
        locationId: {
            type: Number,
            required: null,
        },
        locations: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedLocation: '',
        };
    },
    computed: {
        locationMap() {
            return this.locations.reduce(
                (acc, loc) => ({
                    ...acc,
                    [loc.sucursal]: loc,
                }),
                {},
            );
        },

        // Normaliza la estructura de existence_by_store y asegura que siempre exista `units`.
        sortedStores() {
            // Guardar contra presentation o existence_by_store faltante
            const rawExistence = Array.isArray(
                this.presentation && this.presentation.existence_by_store,
            )
                ? this.presentation.existence_by_store
                : [];

            const existenceMap = new Map(
                rawExistence.map((storeData) => {
                    // Normalizar distintos nombres posibles: units, existence, qty
                    const rawUnits =
                        storeData.units ??
                        storeData.existence ??
                        storeData.qty ??
                        0;
                    const units = Number.isFinite(Number(rawUnits))
                        ? Number(rawUnits)
                        : 0;

                    return [
                        storeData.store,
                        {
                            ...storeData,
                            units,
                        },
                    ];
                }),
            );

            return this.locations.map((location) => {
                const storeName = location.sucursal;
                if (existenceMap.has(storeName)) {
                    return existenceMap.get(storeName);
                } else {
                    return {
                        store: storeName,
                        units: 0,
                        is_drive_thru: false,
                    };
                }
            });
        },
    },
    methods: {
        getStoreName(storeId) {
            const location = this.locations.find(
                (loc) => loc.sucursal === storeId,
            );
            return location ? location.public_name : '';
        },
        closeDialog() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.card-header {
    background-color: #4dbfad;
    position: sticky;
    top: 0;
    color: white;
    align-items: center;
    width: 640px;
    display: flex;
    justify-content: center;
    position: relative;
    padding: 12px 16px !important;
    border-radius: 30px 30px 0 0;
}

.header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.header-title {
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 26pt;
    font-weight: bold;
    margin: 0;
    color: white;
    justify-content: center;
    align-items: center;
    align-content: center;
    align-self: center;
    text-align: center;
}

.boton-cerrar-x {
    color: #ffffff;
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    font-size: 25px;
    padding-bottom: 10px;
}

.boton-cerrar-x:hover {
    color: #d6d6d6;
}

.legend-section {
    margin-bottom: 16px;
    border-bottom: 1px solid #e0e0e0;
}

.stock-container {
    column-count: 2;
    column-gap: 1px;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 5px;
    padding-bottom: 5px;
}

.column-container {
    break-inside: avoid;
    display: inline-block;
    width: 100%;
    text-align: left;
}

.cube {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    line-height: 1;
    min-width: 30px;
    background-color: var(--aguamarina-tropical);
    border-radius: 6px;
    margin-right: 4px;
    margin-bottom: 2px;
    font-family: 'Trebuchet MS';
    font-weight: bold;
    color: white;
}

.drive-thru {
    background-color: #4eb6e4;
}

.disabled {
    color: black;
    background-color: white;
    border: 1px solid black;
}

.storeName {
    font-family: 'Trebuchet MS';
    color: #414141;
}

.icono-drive-thru {
    display: inline-block;
    aspect-ratio: 1;
    width: 30px;
    background-image: url('@/assets/carro-autoservicio.svg');
    background-size: contain;
    background-repeat: no-repeat;
    vertical-align: middle;
}
</style>
